import type { ListAssetsDto, ListItemDto } from "../../types/dto";

export const toListAssetsDto = (list: ListItemDto): ListAssetsDto => {
    return {
        listId: list.listId,
        listType: list.listType,
        crmIntegrationType: list.crmIntegrationType,
        crmObjectType: list.crmObjectType,
    };
};
